import { Button, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useRef } from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import { useReactToPrint } from 'react-to-print';

export default function CertificateGenerator({ noDownload, name }) {
  const certificateRef = useRef(null);
  const reactToPrintFn = useReactToPrint({
    content: () => certificateRef.current,
    documentTitle: 'Interval Course Completion Certificate',
  });
  return (
    <Box
      display={'flex'}
      sx={{
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <Box
        ref={certificateRef}
        sx={{
          position: 'relative',
          width: 1000,
          height: 600,
          margin: 'auto',
          mt: 10,
        }}
      >
        <img width={'100%'} height={'100%'} src="/static/certificateTemplate.png" alt="certificate" />
        <Typography
          variant="h4"
          sx={{
            width: 470,
            position: 'absolute',
            textAlign: 'center',
            bottom: 280,
            left: 120,
          }}
        >
          {name ?? 'Name'}
        </Typography>
      </Box>
      {!noDownload && (
        <Button
          startIcon={<DownloadIcon />}
          onClick={reactToPrintFn}
          variant="contained"
          color="success"
          sx={{
            color: 'white',
            position: 'absolute',
          }}
        >
          Download
        </Button>
      )}
    </Box>
  );
}
